import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SITE_INSTAGRAM_USER } from '../../config/site';

const Support = () => {
    const { language } = useSelector( store => store );
    const { t } = useTranslation( 'support' );

  return (
    <div className="support">
      <h3>{t("title")}</h3>
      <p>
          {t("part1")}{" "}
          {language === "ru" ? <a
              href={ `https://www.instagram.com/${SITE_INSTAGRAM_USER}/` }
              target="_blank"
              rel="noopener noreferrer"
          >
              <span>@{ SITE_INSTAGRAM_USER }</span>
          </a> : <a onClick={() => window.MeTalk('openSupport')}><span>chat</span></a> }{" "}
          {t("part2")} :)
      </p>
    </div>
  );
};

export default Support;
